// Import external
import { Component, Input } from '@angular/core';

@Component({

    selector: 'syn-page-loader',
    templateUrl: 'page-loader.component.html',
    styleUrls: ['page-loader.component.scss']
})
export class PageLoaderComponent {
    @Input() loading = true;
    @Input() message = 'Chargement en cours';
}
